module.exports = __webpack_public_path__ + "img/private-napolimania-tiramisu-1.8bbde31b.jpg";